import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AcctShell } from "../features/acct/AcctShell";
import { JournalStatsBar } from "../features/acct/JournalStatsBar";
import { JournalToolbar } from "../features/acct/JournalToolbar";
import { JournalTable } from "../features/acct/JournalTable";
import { EntryForm } from "../features/acct/EntryForm";
import { EntryModal } from "../features/acct/EntryModal";
import { useJournal } from "../features/acct/useJournal";
import { NeuInput } from "../components/neu/Neu";

export default function AcctJournalPage() {
  const { t } = useTranslation();
  const journal = useJournal();
  const [creating, setCreating] = useState(false);
  const [selected, setSelected] = useState(null);

  const doReverse = async (entry) => {
    await journal.reverse(entry);
    toast.success(t("acct.entryReversed"));
  };

  return (
    <AcctShell>
      <JournalStatsBar stats={journal.stats}
                       active={journal.statusFilter}
                       onSelect={journal.setStatusFilter} />

      <JournalToolbar query={journal.query} setQuery={journal.setQuery}
                      canPost={journal.canPost} onNew={() => setCreating(true)} />

      <div className="flex items-end gap-3">
        <div className="w-44">
          <p className="label-xs mb-2">{t("acct.periodCode")}</p>
          <NeuInput data-testid="journal-period-filter" type="month"
                    value={journal.period}
                    onChange={(e) => journal.setPeriod(e.target.value)} />
        </div>
      </div>

      {creating ? (
        <EntryForm accounts={journal.accounts} branches={journal.branches}
                   onCancel={() => setCreating(false)}
                   onSaved={() => { setCreating(false); journal.load(); }} />
      ) : null}

      {selected ? <EntryModal entryId={selected} onClose={() => setSelected(null)} /> : null}

      <JournalTable entries={journal.entries}
                    branchNameById={journal.branchNameById}
                    canManage={journal.canManage}
                    onReverse={doReverse} />
    </AcctShell>
  );
}
